import toast, { Toaster, ToastBar, useToaster } from 'react-hot-toast';
import { useEffect } from 'react';
import { useTheme } from '@mui/material';
import { useApp } from '@context/AppContext';
import { ToastConstants } from '@constants/toastConstants';

const ResponsiveToaster = () => {
  const theme = useTheme();
  const { isMobileScreen } = useApp();
  const { toasts } = useToaster();

  // Enforce gutter: cap concurrent custom (blank) toasts to prevent spam stacking
  useEffect(() => {
    const customToasts = toasts.filter(t => t.type === 'blank' || t.type === 'custom');
    if (customToasts.length > ToastConstants.maxCustomToasts) {
      // Dismiss any extras beyond the cap (newest ones disappear as they come in)
      const extras = customToasts.slice(ToastConstants.maxCustomToasts);
      extras.forEach(extra => toast.dismiss(extra.id));
    }
  }, [toasts]);

  const containerTop = isMobileScreen
    ? ToastConstants.mobileMarginTopPx
    : ToastConstants.successMarginTop;

  return (
    <Toaster
      position={ToastConstants.positionTopCenter}
      containerStyle={{
        // react-hot-toast v2: use top/left/right/bottom for offset, not margin
        top: containerTop,
      }}
      toastOptions={{
        duration: 5000,
        position: ToastConstants.positionTopCenter,
        style: {
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.primary,
        },
      }}
    >
      {t => (
        <div
          style={{
            transition: ToastConstants.transition,
            transform: t.visible
              ? ToastConstants.transformVisible
              : ToastConstants.transformHidden,
            opacity: t.visible
              ? ToastConstants.opacityVisible
              : ToastConstants.opacityHidden,
          }}
        >
          <ToastBar toast={t}>
            {({ icon, message }) => (
              <>
                {icon}
                {message}
              </>
            )}
          </ToastBar>
        </div>
      )}
    </Toaster>
  );
};

export default ResponsiveToaster;
